import BaseTable from "./base-table";


function StatisticTable() {
    return (
        <BaseTable>
            <tbody>
                <tr>
                    <td className="border border-gray-300 p-2">_skg_*</td>
                    <td className="border border-gray-300 p-2"><a href="https://skorstensgaard.dk/persondatapolitik">skorstensgaard.dk</a></td>
                    <td className="border border-gray-300 p-2">Vi brugere disse cookies til at gøre bruger oplevelsen bedre.</td>
                    <td className="border border-gray-300 p-2">14 dage</td>
                    <td className="border border-gray-300 p-2">Cookie</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">_ga</td>
                    <td className="border border-gray-300 p-2"><a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">google.com</a></td>
                    <td className="border border-gray-300 p-2">Google Analytics bruger denne cookie til at skelne brugere.</td>
                    <td className="border border-gray-300 p-2">2 år</td>
                    <td className="border border-gray-300 p-2">Cookie</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">_ga_*</td>
                    <td className="border border-gray-300 p-2"><a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">google.com</a></td>
                    <td className="border border-gray-300 p-2">Google Analytics bruger denne cookie til at identificere og spore en individuel session med din enhed.</td>
                    <td className="border border-gray-300 p-2">2 år</td>
                    <td className="border border-gray-300 p-2">Cookie</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">_gid</td>
                    <td className="border border-gray-300 p-2"><a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">google.com</a></td>
                    <td className="border border-gray-300 p-2">Google Analytics bruger denne cookie til at skelne brugere.</td>
                    <td className="border border-gray-300 p-2">24 timer</td>
                    <td className="border border-gray-300 p-2">Cookie</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">_gat_*</td>
                    <td className="border border-gray-300 p-2"><a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">google.com</a></td>
                    <td className="border border-gray-300 p-2">Google Analytics bruger denne cookie til at throttle request.</td>
                    <td className="border border-gray-300 p-2">1 minut</td>
                    <td className="border border-gray-300 p-2">Cookie</td>
                </tr>
            </tbody>
        </BaseTable>
    )
}

export default StatisticTable;